// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"AddNewGoalPop_AddNewGoalPop__VPCSz","modalBody":"AddNewGoalPop_modalBody__b5o7a","formControl":"AddNewGoalPop_formControl__WllSH","add":"AddNewGoalPop_add__kZ7tv"};